export const PI_FILTER_KEY = 'product-intelligence';

export const PI_FILTER_DEFAULTS = {
  preset: '',
  from: '',
  to: '',
  compare: '',
  companyId: '',
  companyName: '',
  module: '',
  featureType: '',
  roleClass: '',
  platform: '',
  sizeBand: '',
  segment: '',
  granularity: '',
  saleFrom: '',
  saleTo: '',
  salePreset: '',
  cohort: '',
  universe: '',
  status: '',
  trial: '',
  started: '',
  plan: '',
  journeyNow: '',
  origin: '',
  shard: '',
};

export const PERIOD_PRESETS = [
  { value: '7', days: 7, label: '7 dias' },
  { value: '30', days: 30, label: '30 dias' },
  { value: '90', days: 90, label: '90 dias' },
];

export const DEFAULT_PRESET = '30';

export const MAX_RANGE_DAYS = 400;

export const MAX_PAGE_SIZE = 200;

export const DEFAULT_PAGE_SIZE = 50;

export const MODULE_OPTIONS = [
  { value: '1', label: 'Sessão' },
  { value: '2', label: 'Controle de Jornada' },
  { value: '3', label: 'Departamento Pessoal' },
  { value: '4', label: 'Relatórios' },
  { value: '5', label: 'Documentos e Assinaturas' },
  { value: '6', label: 'Folha e Integrações' },
  { value: '7', label: 'Desenvolvimento de Pessoas' },
  { value: '8', label: 'Comunicação e Cultura' },
  { value: '9', label: 'Benefícios Corporativos' },
  { value: '10', label: 'Administração' },
  { value: '11', label: 'Sistema' },
];

export const ROLE_CLASS_OPTIONS = [
  { value: '1', label: 'Funcionário' },
  { value: '2', label: 'Gestor' },
  { value: '3', label: 'Admin' },
  { value: '4', label: 'Contador' },
];

export const ROLE_CLASS_MASK = [
  { bit: 1, label: 'Funcionário' },
  { bit: 2, label: 'Gestor' },
  { bit: 4, label: 'Admin' },
  { bit: 8, label: 'Contador' },
];

export const PLATFORM_OPTIONS = [
  { value: '0', label: 'Desconhecida' },
  { value: '1', label: 'Web' },
  { value: '2', label: 'Web V2' },
  { value: '3', label: 'App' },
  { value: '4', label: 'Tablet' },
  { value: '5', label: 'QR Code' },
  { value: '6', label: 'Modo ponto' },
  { value: '7', label: 'Reconhecimento facial' },
  { value: '8', label: 'Express' },
  { value: '9', label: 'API pública' },
  { value: '10', label: 'Sistema' },
  { value: '11', label: 'REP (relógio de ponto)' },
  { value: '12', label: 'WhatsApp' },
];

export const UNKNOWN_PLATFORM = '0';

export const WEB_PLATFORM = '1';

export const WEB_V2_PLATFORM = '2';

export const PLATFORM_BY_ORIGIN_FROM = '2026-10-25';

export const WEB_V2_SESSION_FROM = '';

export const SOURCE_API_OPTIONS = [
  { value: '1', label: 'API V1' },
  { value: '2', label: 'API V2' },
  { value: '3', label: 'Derivação' },
];

export const SIZE_BAND_OPTIONS = [
  { value: 'A', label: 'Porte A', range: '100+ funcionários' },
  { value: 'B', label: 'Porte B', range: '50 a 99' },
  { value: 'C', label: 'Porte C', range: '21 a 49' },
  { value: 'D', label: 'Porte D', range: '11 a 20' },
  { value: 'E', label: 'Porte E', range: 'até 10' },
];

export const profileText = (value) => {
  const text = typeof value === 'string' ? value.trim() : '';
  return text ? 'Perfil ' + text : '';
};

export const JOURNEY_OPTIONS = [
  { value: '0', label: 'Lead' },
  { value: '1', label: 'Onboarding' },
  { value: '2', label: 'Middle' },
  { value: '3', label: 'Ongoing' },
  { value: '4', label: 'Resale' },
];

export const journeyLabel = (value) => {
  const key = typeof value === 'number' ? String(value) : (typeof value === 'string' ? value.trim() : '');
  const found = JOURNEY_OPTIONS.filter((option) => option.value === key)[0];
  return found ? found.label : '';
};

export const journeyText = (value) => {
  const label = journeyLabel(value);
  return label ? 'Jornada ' + label : '';
};

export const SIZE_BAND_FILTER_OPTIONS = SIZE_BAND_OPTIONS.map((option) => ({
  value: option.value,
  label: option.label + ' (' + option.range + ')',
}));

export const GRANULARITY_OPTIONS = [
  { value: 'day', label: 'Diária' },
  { value: 'week', label: 'Semanal' },
  { value: 'month', label: 'Mensal' },
];

export const GLOBAL_FIELDS = [
  'period', 'compare', 'company', 'module', 'featureType', 'roleClass', 'platform', 'sizeBand', 'segment', 'granularity',
];

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
const COMPANY_ID = /^[0-9A-Fa-f-]{1,40}$/;
const SMALL_INTEGER = /^\d{1,4}$/;
const SIZE_BAND = /^[A-E]$/;
const DAY_MS = 86400000;

const pad2 = (value) => (value < 10 ? '0' : '') + value;

const valuesOf = (options) => options.map((option) => option.value);

const inOptions = (options, value) => valuesOf(options).indexOf(value) !== -1;

const text = (value) => (value === null || value === undefined ? '' : String(value));

const trimmed = (value, max) => {
  const clean = text(value).replace(/\s+/g, ' ').trim();
  return clean.length > max ? clean.substring(0, max) : clean;
};

const brDate = (value) => (DATE_ONLY.test(text(value)) ? text(value).split('-').reverse().join('/') : '');

const ORIGIN_PENDING = 'a API nova passar a reconhecer a web pelo endereço da tela';

const SESSION_PENDING = 'a V2 passar a registrar a abertura do sistema';

const APP_ACTIONS = 'inclusive as feitas pelo app (humor, assinatura de documentos e outras telas do app)';

const untilText = (date, pending) => 'até ' + (date || pending);

const capitalized = (value) => value.charAt(0).toUpperCase() + value.substring(1);

export const webV2PlatformNote = (originFrom, sessionFrom) => {
  const origin = brDate(originFrom);
  const session = brDate(sessionFrom);
  if (origin && origin === session) {
    return 'Quebra de série: até ' + origin + ', "Web V2" contava todas as ações gravadas pela API nova, ' + APP_ACTIONS + ', '
      + 'e a abertura da V2 não era registrada; por isso, nela, "em uso" ficava igual aos ativos e "abriram sem agir" em zero. '
      + 'A partir dessa data, conta também quem abriu a V2 no navegador (quem agiu no dia continua no canal onde agiu), '
      + 'e as ações do app sem canal informado passam para "Desconhecida". Não compare períodos dos dois lados dessa data.';
  }
  const sessionText = session
    ? 'Até ' + session + ', a abertura da V2 não era registrada; por isso, nela, "em uso" ficava igual aos ativos e "abriram sem agir" em zero'
    : 'Até ' + SESSION_PENDING + ', "em uso" na Web V2 ficava igual aos ativos e "abriram sem agir" em zero';
  return 'Quebra de série em duas etapas. ' + capitalized(untilText(origin, ORIGIN_PENDING)) + ', "Web V2" contava todas as ações '
    + 'gravadas pela API nova, ' + APP_ACTIONS + '; depois, as ações do app sem canal informado passam para "Desconhecida". '
    + sessionText + '; depois, conta também quem abriu a V2 no navegador (quem agiu no dia continua no canal onde agiu). '
    + 'Não compare períodos dos dois lados dessas datas.';
};

export const unknownPlatformNote = (originFrom) => 'Quebra de série: ' + untilText(brDate(originFrom), ORIGIN_PENDING)
  + ', as ações do app gravadas pela API nova (humor, assinatura de documentos e outras telas do app) contavam em "Web V2"; '
  + 'depois, sem canal informado, contam aqui em "Desconhecida". Não compare períodos dos dois lados dessa data.';

export const webPlatformNote = (originFrom) => 'Quebra de série: ' + untilText(brDate(originFrom), ORIGIN_PENDING)
  + ', as ações gravadas pela API nova a partir do painel antigo ou do MarQWeb contavam em "Web V2"; depois, contam aqui em "Web" '
  + '(o MarQWeb ainda não tem canal próprio e conta como Web). Não compare períodos dos dois lados dessa data.';

export const platformNote = (value) => {
  const key = text(value);
  if (key === WEB_V2_PLATFORM) return webV2PlatformNote(PLATFORM_BY_ORIGIN_FROM, WEB_V2_SESSION_FROM);
  if (key === UNKNOWN_PLATFORM) return unknownPlatformNote(PLATFORM_BY_ORIGIN_FROM);
  if (key === WEB_PLATFORM) return webPlatformNote(PLATFORM_BY_ORIGIN_FROM);
  return '';
};

export const isoDate = (date) =>
  date.getFullYear() + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate());

export const parseIsoDate = (value) => {
  const match = DATE_ONLY.exec(text(value));
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return date;
};

const utcDay = (iso) => {
  const match = DATE_ONLY.exec(iso);
  return Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

export const addDays = (iso, days) => {
  if (!parseIsoDate(iso)) return '';
  const shifted = new Date(utcDay(iso) + days * DAY_MS);
  return shifted.getUTCFullYear() + '-' + pad2(shifted.getUTCMonth() + 1) + '-' + pad2(shifted.getUTCDate());
};

export const daysBetween = (fromIso, toIso) => {
  if (!parseIsoDate(fromIso) || !parseIsoDate(toIso)) return null;
  return Math.round((utcDay(toIso) - utcDay(fromIso)) / DAY_MS);
};

export const todayIso = (now) => isoDate(now instanceof Date ? now : new Date());

const presetOf = (value) => {
  for (let i = 0; i < PERIOD_PRESETS.length; i++) {
    if (PERIOD_PRESETS[i].value === value) return PERIOD_PRESETS[i];
  }
  return null;
};

const presetPeriod = (preset, today) => {
  const to = addDays(today, -1);
  return { from: addDays(to, -(preset.days - 1)), to: to, days: preset.days, preset: preset.value, custom: false };
};

export const rangeError = (from, to, today) => {
  if (!parseIsoDate(from) || !parseIsoDate(to)) return 'Informe as duas datas do período.';
  if (from > to) return 'A data inicial é depois da data final.';
  if (to > today) return 'A data final não pode ser depois de hoje.';
  if (daysBetween(from, to) > MAX_RANGE_DAYS) return 'O período máximo é de ' + MAX_RANGE_DAYS + ' dias.';
  return null;
};

export const resolvePeriod = (filters, now) => {
  const source = filters || {};
  const today = todayIso(now);
  const fallback = presetPeriod(presetOf(source.preset) || presetOf(DEFAULT_PRESET), today);
  const hasCustom = !!(source.from || source.to);
  if (!hasCustom) return Object.assign({ error: null }, fallback);
  const error = rangeError(source.from, source.to, today);
  if (error) return Object.assign({ error: error }, fallback);
  return {
    from: source.from,
    to: source.to,
    days: daysBetween(source.from, source.to) + 1,
    preset: 'custom',
    custom: true,
    error: null,
  };
};

export const previousPeriod = (period) => {
  if (!period || !period.from || !period.days) return null;
  const to = addDays(period.from, -1);
  return { from: addDays(to, -(period.days - 1)), to: to };
};

export const compareEnabled = (filters) => !filters || filters.compare !== '0';

export const applyPreset = (filters, preset) =>
  Object.assign({}, filters, { preset: preset === DEFAULT_PRESET ? '' : preset, from: '', to: '' });

export const applyCustomRange = (filters, from, to) =>
  Object.assign({}, filters, { preset: '', from: text(from), to: text(to) });

export const applyCompare = (filters, enabled) =>
  Object.assign({}, filters, { compare: enabled ? '' : '0' });

export const sanitizeFilters = (filters) => {
  const source = filters || {};
  const clean = Object.assign({}, PI_FILTER_DEFAULTS);
  if (presetOf(source.preset)) clean.preset = source.preset === DEFAULT_PRESET ? '' : source.preset;
  if (parseIsoDate(source.from)) clean.from = source.from;
  if (parseIsoDate(source.to)) clean.to = source.to;
  if (source.compare === '0') clean.compare = '0';
  if (COMPANY_ID.test(text(source.companyId))) {
    clean.companyId = text(source.companyId);
    clean.companyName = trimmed(source.companyName, 120);
  }
  if (inOptions(MODULE_OPTIONS, text(source.module))) clean.module = text(source.module);
  if (SMALL_INTEGER.test(text(source.featureType))) clean.featureType = String(Number(source.featureType));
  if (inOptions(ROLE_CLASS_OPTIONS, text(source.roleClass))) clean.roleClass = text(source.roleClass);
  if (inOptions(PLATFORM_OPTIONS, text(source.platform))) clean.platform = text(source.platform);
  if (SIZE_BAND.test(text(source.sizeBand))) clean.sizeBand = text(source.sizeBand);
  clean.segment = trimmed(source.segment, 60);
  if (inOptions(GRANULARITY_OPTIONS, text(source.granularity))) clean.granularity = text(source.granularity);
  return clean;
};

const has = (list, field) => list.indexOf(field) !== -1;

const positiveInteger = (value, fallback, max) => {
  const number = Math.floor(Number(value));
  if (!isFinite(number) || number < 1) return fallback;
  return max && number > max ? max : number;
};

export const buildApiQuery = (filters, options) => {
  const settings = options || {};
  const fields = Array.isArray(settings.fields) ? settings.fields : GLOBAL_FIELDS;
  const clean = sanitizeFilters(filters);
  const params = {};
  if (has(fields, 'period')) {
    const period = resolvePeriod(clean, settings.now);
    params.from = period.from;
    params.to = period.to;
  }
  if (has(fields, 'compare')) params.compare = compareEnabled(clean) ? 'true' : 'false';
  if (has(fields, 'company') && clean.companyId) params.companyId = clean.companyId;
  if (has(fields, 'module') && clean.module) params.module = clean.module;
  if (has(fields, 'featureType') && clean.featureType) params.featureType = clean.featureType;
  if (has(fields, 'roleClass') && clean.roleClass) params.roleClass = clean.roleClass;
  if (has(fields, 'platform') && clean.platform) params.platform = clean.platform;
  if (has(fields, 'sizeBand') && clean.sizeBand) params.sizeBand = clean.sizeBand;
  if (has(fields, 'segment') && clean.segment) params.segment = clean.segment;
  if (has(fields, 'granularity')) params.granularity = clean.granularity || settings.defaultGranularity || 'day';
  const extra = settings.extra || {};
  if (extra.page !== undefined) params.page = String(positiveInteger(extra.page, 1));
  if (extra.pageSize !== undefined) params.pageSize = String(positiveInteger(extra.pageSize, DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE));
  if (extra.sort) params.sort = text(extra.sort);
  if (extra.sort && extra.desc !== undefined) params.desc = extra.desc ? 'true' : 'false';
  if (extra.search) params.search = trimmed(extra.search, 60);
  ['type', 'stage', 'dimension', 'shard', 'band', 'journey', 'signal', 'contract'].forEach((key) => {
    if (extra[key]) params[key] = text(extra[key]);
  });
  return params;
};

export const toQueryString = (params) => {
  const source = params || {};
  return Object.keys(source)
    .filter((key) => source[key] !== '' && source[key] !== null && source[key] !== undefined)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(String(source[key])))
    .join('&');
};

export const withQuery = (url, params) => {
  const query = toQueryString(params);
  if (!query) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + query;
};

export const optionLabel = (options, value) => {
  const wanted = text(value);
  for (let i = 0; i < options.length; i++) {
    if (options[i].value === wanted) return options[i].label;
  }
  return wanted;
};

export const roleClassLabels = (mask) => {
  const value = Number(mask) || 0;
  return ROLE_CLASS_MASK.filter((item) => (value & item.bit) === item.bit).map((item) => item.label);
};

export const filterSummary = (filters, now) => {
  const clean = sanitizeFilters(filters);
  const period = resolvePeriod(clean, now);
  const parts = [];
  parts.push(period.custom ? 'Período personalizado' : 'Últimos ' + period.days + ' dias');
  if (clean.companyId) parts.push('Empresa: ' + (clean.companyName || clean.companyId));
  if (clean.module) parts.push('Módulo: ' + optionLabel(MODULE_OPTIONS, clean.module));
  if (clean.featureType) parts.push('Funcionalidade: ' + clean.featureType);
  if (clean.roleClass) parts.push('Papel do usuário: ' + optionLabel(ROLE_CLASS_OPTIONS, clean.roleClass));
  if (clean.platform) parts.push('Plataforma: ' + optionLabel(PLATFORM_OPTIONS, clean.platform));
  if (clean.sizeBand) parts.push(optionLabel(SIZE_BAND_OPTIONS, clean.sizeBand));
  if (clean.segment) parts.push('Perfil da empresa: ' + clean.segment);
  return parts;
};

export const nextSort = (current, key, startDescending) => {
  const state = current || {};
  if (state.sort === key) return { sort: key, desc: !state.desc };
  return { sort: key, desc: startDescending !== false };
};

export const ariaSort = (current, key) => {
  const state = current || {};
  if (state.sort !== key) return 'none';
  return state.desc ? 'descending' : 'ascending';
};

const sortValue = (row, key) => {
  const value = row ? row[key] : null;
  if (value && typeof value === 'object' && 'value' in value) return value.value;
  return value;
};

const isEmptySortValue = (value) =>
  value === null || value === undefined || value === '' || (typeof value === 'number' && !isFinite(value));

export const sortRows = (rows, key, desc) => {
  const list = (rows || []).slice();
  if (!key) return list;
  const direction = desc ? -1 : 1;
  return list
    .map((row, index) => ({ row: row, index: index }))
    .sort((a, b) => {
      const left = sortValue(a.row, key);
      const right = sortValue(b.row, key);
      const leftEmpty = isEmptySortValue(left);
      const rightEmpty = isEmptySortValue(right);
      if (leftEmpty && rightEmpty) return a.index - b.index;
      if (leftEmpty) return 1;
      if (rightEmpty) return -1;
      let result;
      if (typeof left === 'number' && typeof right === 'number') result = left - right;
      else if (typeof left === 'boolean' && typeof right === 'boolean') result = (left ? 1 : 0) - (right ? 1 : 0);
      else result = String(left).localeCompare(String(right), 'pt-BR');
      return result === 0 ? a.index - b.index : result * direction;
    })
    .map((item) => item.row);
};

export const searchRows = (rows, term, keys) => {
  const wanted = trimmed(term, 60).toLowerCase();
  if (!wanted) return (rows || []).slice();
  return (rows || []).filter((row) =>
    keys.some((key) => text(row ? row[key] : '').toLowerCase().indexOf(wanted) !== -1));
};

const FIELD_OF_FILTER = {
  companyId: 'company',
  module: 'module',
  featureType: 'featureType',
  roleClass: 'roleClass',
  platform: 'platform',
  sizeBand: 'sizeBand',
  segment: 'segment',
  granularity: 'granularity',
};

export const ignoredFilters = (filters, fields) => {
  const clean = sanitizeFilters(filters);
  const list = Array.isArray(fields) ? fields : GLOBAL_FIELDS;
  const labels = [];
  Object.keys(FIELD_OF_FILTER).forEach((key) => {
    if (!clean[key] || has(list, FIELD_OF_FILTER[key])) return;
    if (key === 'companyId') labels.push('Empresa: ' + (clean.companyName || clean.companyId));
    else if (key === 'module') labels.push('Módulo: ' + optionLabel(MODULE_OPTIONS, clean.module));
    else if (key === 'featureType') labels.push('Funcionalidade: ' + clean.featureType);
    else if (key === 'roleClass') labels.push('Papel do usuário: ' + optionLabel(ROLE_CLASS_OPTIONS, clean.roleClass));
    else if (key === 'platform') labels.push('Plataforma: ' + optionLabel(PLATFORM_OPTIONS, clean.platform));
    else if (key === 'sizeBand') labels.push(optionLabel(SIZE_BAND_OPTIONS, clean.sizeBand));
    else if (key === 'segment') labels.push('Perfil da empresa: ' + clean.segment);
    else labels.push('Granularidade: ' + optionLabel(GRANULARITY_OPTIONS, clean.granularity));
  });
  return labels;
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piQuery.js